import React, { useState } from "react";
import styles from "./shareIcon.scss";
import ShareBar from "@tw/shared-ui-components/lib/components/shareBar/shareBar";

export default function ShareIcon({ itemCode, product }) {
  const [selectedShareId, setShareId] = useState();
  const [showPopupShare, setShowPopupShare] = useState(false);

  const handleShared = (shareId) => {
    setShowPopupShare(true);
    setShareId(shareId);

  };

  return (
    <div className={styles["shareIconContainer"]}>
      <div className={styles["shareIconDiv"]}>
        <div className={styles["left-section"]}></div>
        <div
          className={styles["right-section"]}
          onClick={() => handleShared(itemCode)}
        >
          <div className={styles["icon"]}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9993 4.19233C10.7699 4.17989 10.6615 4.28835 10.6739 4.51772L10.65 5.30732C10.6489 5.55024 10.7631 5.66443 10.9926 5.64988L14.2116 5.57438L9.43405 10.352C9.27135 10.5147 9.27061 10.6766 9.43182 10.8378L9.99604 11.4021C10.1572 11.5633 10.3192 11.5625 10.4819 11.3998L15.2595 6.62223L15.184 9.84127C15.1694 10.0708 15.2836 10.1849 15.5266 10.1838L16.3162 10.16C16.5455 10.1724 16.654 10.0639 16.6415 9.83458L16.6661 4.49022C16.6806 4.26073 16.5731 4.15326 16.3437 4.1678L10.9993 4.19233ZM7.75916 6.13996C7.96716 6.06551 8.09289 5.84663 8.03411 5.63368L7.87815 5.06862C7.81938 4.85567 7.59846 4.72959 7.38936 4.80086C4.70784 5.7149 2.77832 8.25472 2.77832 11.2468C2.77832 15.0071 5.82664 18.0554 9.58694 18.0554C12.7378 18.0554 15.3874 15.9158 16.1647 13.0106C16.2218 12.7972 16.0812 12.5852 15.8648 12.5408L15.2906 12.4231C15.0742 12.3787 14.8642 12.5188 14.8038 12.7314C14.1584 15.0045 12.0664 16.6693 9.58694 16.6693C6.59221 16.6693 4.16451 14.2416 4.16451 11.2468C4.16451 8.89422 5.66328 6.89008 7.75916 6.13996Z"
                fill="#546223"
              />
            </svg>
          </div>
          <div className={styles["text"]}>分享購</div>
        </div>
      </div>

      <ShareBar
        shareInfo={{ type: "products", id: selectedShareId }}
        setShowShareBar={setShowPopupShare}
        showPopup={showPopupShare}
        product={product}
      />
    </div>
  );
}
